import { render, staticRenderFns } from "./user-lookup.vue?vue&type=template&id=5175c924"
import script from "./user-lookup.vue?vue&type=script&lang=ts"
export * from "./user-lookup.vue?vue&type=script&lang=ts"
import style0 from "./user-lookup.vue?vue&type=style&index=0&id=5175c924&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports